const MODEL_ASSETS = [
  "/models/gladiator.glb",
  "/models/weapon-sword.glb",
  "/models/weapon-spear.glb",
  "/models/shield-rectangle.glb",
  "/models/shield-round.glb",
  "/models/colormap.png",
];

let viewerModulePromise = null;
let assetsWarmed = false;

function scheduleIdle(work, timeout = 180) {
  if (typeof window === "undefined") return () => {};
  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(work, { timeout });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(work, 60);
  return () => window.clearTimeout(id);
}

export function warmBattle3DResources({ immediate = false } = {}) {
  if (typeof window === "undefined") return Promise.resolve();

  if (!viewerModulePromise) {
    viewerModulePromise = import("@/components/battle3d/BattleReplay3DViewer");
  }

  if (!assetsWarmed) {
    assetsWarmed = true;
    const warmAssets = () => {
      MODEL_ASSETS.forEach((url) => {
        window.fetch(url, { credentials: "same-origin" }).catch(() => {});
      });
    };

    if (immediate) {
      warmAssets();
    } else {
      scheduleIdle(warmAssets, 260);
    }
  }

  return viewerModulePromise;
}

export function scheduleBattle3DMount(onReady) {
  if (typeof window === "undefined") return () => {};

  let cancelled = false;
  let finished = false;
  let rafA = 0;
  let rafB = 0;
  let fallbackId = 0;
  let cancelIdle = () => {};

  const finish = () => {
    if (cancelled || finished) return;
    finished = true;
    onReady();
  };

  rafA = window.requestAnimationFrame(() => {
    rafB = window.requestAnimationFrame(() => {
      cancelIdle = scheduleIdle(finish, 220);
      fallbackId = window.setTimeout(finish, 180);
    });
  });

  return () => {
    cancelled = true;
    if (rafA) window.cancelAnimationFrame(rafA);
    if (rafB) window.cancelAnimationFrame(rafB);
    if (fallbackId) window.clearTimeout(fallbackId);
    cancelIdle();
  };
}